export default __webpack_public_path__ + "static/slide1-48f56ca03329a2f4f02cfaf4a4d92b4f.jpg";